import Vue from "vue";
import Vuex from "vuex";
import contactus from "./contactus"



Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    contactus,
  }
});
